import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { practiceAreas as areas } from '../../content/practiceAreas';
import useLangPrefix from '../../hooks/useLangPrefix';
import './PracticeAreas.css';

function PracticeAreas({ variant }) {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();
  const listedAreas = areas.filter((area) =>
    variant === 'home' ? area.showOnHome : area.showInIndex
  );

  return (
    <section className="py-5 py-lg-6 bg-light border-top border-bottom" id="practice-areas">
      <div className="container">
        <div className="row justify-content-center mb-4 mb-lg-5">
          <div className="col-lg-8 text-center">
            <h2 className="h3 fw-semibold text-navy mb-2">{t('practiceAreas.heading')}</h2>
            <p className="text-muted mb-0">{t('practiceAreas.subheading')}</p>
          </div>
        </div>
        <div className="row g-4">
          {listedAreas.map((area) => (
            <div className="col-md-6 col-lg-3" key={area.key}>
              <Link to={`${langPrefix}${area.path}`} className="text-decoration-none">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="areaIcon">
                      <img src={area.icon} alt=""/>
                    </div>
                    <h3 className="h6 fw-semibold text-navy mb-3">
                      {t(`practiceAreas.areas.${area.key}.cardTitle`, {
                        defaultValue: t(`practiceAreas.areas.${area.key}.title`),
                      })}
                    </h3>
                    <p className="card-text small text-muted mb-0">
                      {t(`practiceAreas.areas.${area.key}.description`)}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PracticeAreas;
